import React from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import PlayIcon from '@material-ui/icons/PlayArrow';

import Banner from '../components/layout/Banner';
import PlayButton from '../components/button/PlayButton';
import PlayButton2 from '../components/button/PlayButton2';

const useStyles = makeStyles(theme => ({
  dark: {
    color: '#fff',
    backgroundPosition: 'center top',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundColor: '#333',
    paddingBottom: theme.spacing(10),
  },
  awards: {
    maxWidth: '600px',
    margin: '0 auto',
    textAlign: 'center',
  },
  awardTitle: {
    color: theme.palette.secondary.main,
    marginTop: theme.spacing(6)
  },
  awardSubTitle: {
    fontWeight: 500,
    marginBottom: theme.spacing(3),
    color: theme.palette.secondary.main
  },
  awardDate: {
    fontWeight: 400,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    color: '#fff',
  },
  awardText: {
    whiteSpace: 'pre-line',
    lineHeight: '1.5em',
    fontWeight: 300,
    fontSize: '16px',
    marginBottom: theme.spacing(3),
  },
  events: {
    paddingBottom: theme.spacing(10),
  },
  name: {
    fontWeight: 500,
    fontSize: '20px',
    lineHeight: '24px'
  },
  eventTitle: {
    fontWeight: 500,
    marginTop: theme.spacing(5)
  },
  eventSubTitle: {
    fontWeight: 400,
    color: theme.palette.secondary.main,
    marginBottom: theme.spacing(3)
  },
  eventtime: {
    fontWeight: 300,
    fontSize: '14px',
    lineHeight: '20px',
    // color: 'rgba(0,0,0,0.8)',
    paddingTop: theme.spacing(1)
  },
  eventdate: {
    fontWeight: 400,
    // color: 'rgba(0,0,0,0.8)',
    textTransform: 'uppercase',
    letterSpacing: '1px',
    paddingTop: theme.spacing(1) / 2
  },
  card: {
    cursor: 'pointer',
    // border: '2px solid #666',
    // '&:hover': {
    //   border: '2px solid #eec500',
    // }
  },
  heading: {
    padding: theme.spacing(3)
  },
  container: {
    position: 'relative',
    height: '0',
    paddingBottom: '56.25%',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundColor: '#ccc',
    textAlign: 'center',
    color: 'rgba(255,255,255,0.75)',
    transition: 'background-image 0.5s ease-in-out'
  },
  icon: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: '-24px',
    marginLeft: '-24px',
  },
  play: {
    fontSize: '3em',
  },
  buttons: {
    padding: theme.spacing(3)
  },
  button: {
    fontSize: '0.7rem'
  },
  awardButtons: {
    textAlign: 'center'
  },
  buttonContainer: {
    display: 'inline-block',
    margin: theme.spacing(1),
  }
}));

export default (props) => {
  const history = useHistory();
  const handleClick = (id) => {
    history.push(`/player/${id}`);
  };
  const handleClick2 = (id) => {
    history.push(`/player2/${id}`);
  };
  const classes = useStyles();
  return (
    <>
      <div className={classes.dark} style={{ backgroundImage: `url('https://events-public-assets.s3-ap-southeast-2.amazonaws.com/events/aeea2020/pinnacles/background.dark.png')` }}>
        <Banner isAuthenticated={props.isAuthenticated} Logout={props.Logout} />
        <Container>
          <div className={classes.awards}>
            <h1 className={classes.awardTitle}>{props.config.awardPanel.title}</h1>
            <h2 className={classes.awardSubTitle}>{props.config.awardPanel.subtitle}</h2>
            <h3 className={classes.awardDate}>{props.config.awardPanel.eventDate}</h3>
            <p className={classes.awardText}>{props.config.awardPanel.description}</p>
          </div>
          <div className={classes.awardButtons}>
          {props.config.awardPanel.events && props.config.awardPanel.events.map((event, index) => (
            <div key={index}>
              <div className={classes.buttonContainer}><PlayButton2 config={event} handleClick={() => handleClick2(event.id)} /></div>
              <div className={classes.buttonContainer}><Button size="small" color="secondary" variant="outlined" style={{ color: '#fff' }} className={classes.button} href={event.calendarUrl}>add to calendar</Button></div>
            </div>
          ))}
          </div>
        </Container>
      </div>
      <Container>
        <h2 className={classes.eventTitle}>{props.config.eventPanel.title}</h2>
        <h3 className={classes.eventSubTitle}>{props.config.eventPanel.subtitle}</h3>
        <Grid container direction="row" spacing={3} className={classes.events} >
          {props.config.eventPanel.events && props.config.eventPanel.events.map((event, index) => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
              <Card id={`card-${event.id}`} className={classes.card}>
                <div onClick={(e) => handleClick(event.id)}>
                  <div className={classes.heading} >
                    <div><h2 className={classes.name}>{event.name}</h2></div>
                    <div><h5 className={classes.eventtime}>{event.eventtime}</h5></div>
                    <div><h6 className={classes.eventdate}>{event.eventdate}</h6></div>
                  </div>
                  <div id={`container-${event.id}`} className={classes.container} style={{ backgroundImage: `url("${event.imageUrl}")` }}>
                    <div className={classes.icon}><PlayIcon className={classes.play} /></div>
                  </div>
                </div>
                <div className={classes.buttons}>
                  <Grid container direction="row" >
                    <Grid item style={{ flexGrow: 1 }}><PlayButton config={event} handleClick={() => handleClick(event.id)} /></Grid>
                    {/* <Grid item><Button size="small" color="default" className={classes.button} href={event.calendarUrl}>add to calendar</Button></Grid> */}
                  </Grid>
                </div>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </>
  );
};